(() => {
  // src/js/components/equipmentfilter.js
  var EquipmentFilter = class {
    static create() {
      const script_chunk = document.createElement("script");
      const script = document.createElement("script");
      script_chunk.onload = function() {
      };
      script.addEventListener("load", function() {
      }, false);
      script.src = "/app/themes/Acolyte/dist/js/equipement.js";
      script_chunk.src = "/app/themes/Acolyte/dist/js/chunk-vendors.js";
      document.head.appendChild(script_chunk);
      document.head.appendChild(script);
    }
  };
  function render() {
    EquipmentFilter.create();
  }
  window.Store.components.equipmentfilter = {
    render: null
  };
  window.Store.components.equipmentfilter.render = render;
})();
